import { Role } from '@anecdotes/api-contracts';
import { createAction, props } from '@ngrx/store';

export const RoleActions = {
  loadRoles: createAction('[Role] load roles'),
  rolesLoaded: createAction('[Role] roles loaded', props<{ roles: Role[] }>()),
  createRole: createAction('[Role] create role', props<{ role: Role }>()),
  roleCreated: createAction('[Role] role created', props<{ role: Role }>()),
  roleCreationFailed: createAction('[Role] role creation failed', props<{ role: Role }>()),
  updateRole: createAction('[Role] update role', props<{ role: Role }>()),
  roleUpdated: createAction('[Role] role updated', props<{ role: Role }>()),
  roleUpdateFailed: createAction('[Role] role update failed', props<{ role: Role }>()),
  deleteRole: createAction('[Role] delete role', props<{ role: Role }>()),
  roleDeleted: createAction('[Role] role deleted', props<{ role: Role }>()),
  roleDeleteFailed: createAction('[Role] role delete failed', props<{ role: Role }>()),
};
